export default __webpack_public_path__ + "static/media/HGTV.51d0762a.svg";